// import NewOfferingButton, {EditOfferingButton, DeleteOfferingButton} from 'components/NewOfferingButton';
import NewFormButton, {EditFormButton, DeleteFormButton} from 'components/forms/NewFormButton';
import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import ReactTable from 'react-table';
import { Route, Switch, useLocation, useHistory } from "util/router.js";
import {loadForms} from 'store/actions/formActions'
import {loadOfferings} from 'store/actions/offeringsActions'
import {Helmet} from 'react-helmet'
import ShareButton from 'components/ShareButton'
import OfferingSection from 'components/OfferingSection';
import VisibilityIcon from '@material-ui/icons/Visibility';
import IconButton from '@material-ui/core/IconButton'
import {NavLink, useRouter} from "util/router";
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Section from 'components/Section'
import moment from 'moment-timezone'
import SubmissionsPage from 'pages/formSubmissions'

function FormsTable(props) {

    const router = useRouter()
  const forms = useSelector(state => state.instructor.forms);
  const tableData = forms.map(val => {

    const pathName = `${router.pathname}/form/${val.id}`

      const actions = (val.deleted) ? <></> : (
      // we've added some custom button actions
      <div className="d-flex d-row justify-content-end">
            <NavLink
            to={pathName}>
                <IconButton onClick={() => {
                    
                }}>
                    <VisibilityIcon/>    
                </IconButton>
            </NavLink>
            <EditFormButton 
            {...props}
            toEdit={val}
            />
            <DeleteFormButton 
            toDelete={val}
            />
      </div>
    )
    

    return {
      ...val,
      actions: actions
    }
  })

  const tableColumns = [
      {
      Header: "Name",
      accessor: "name",
      minWidth: 150
      },
      {
      Header: "Actions",
      accessor: "actions",
      sortable: false,
      width: 150,
      filterable: false
      }
  ]

  return (
  <div>
    
        <ReactTable
            data={tableData}
            filterable={true}
            columns={tableColumns}
            defaultPageSize={10}
            showPaginationTop={false}
            showPaginationBottom={true}
            className="-highlight"
        />
  </div>
  )
}


function FormsPage(props) {

  const {match } = props;
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch();
  const partnerId = useSelector(state => state.instructor.instructor.platformID);
  const partner = useSelector(state => state.instructor.instructor);
  useEffect(() => {
    // dispatch
    if (partnerId) {
      dispatch(loadOfferings())
      dispatch(loadForms())
    }
    
  }, [dispatch, partnerId]);

  function Packages() {

    return (<>

    <Helmet>
      <title>Forms</title>
    </Helmet>
    <div className="container px-0 "  >
      {true && (
        <section>
          <div className='d-flex d-row justify-content-between align-items-center mb-4'>
            <h2 className="font-weight-bold">Forms</h2>
            <NewFormButton className="float-right" {...props}/>
          </div>
          {/* <p><big>Use a promo code to offer a flash sale or quick discount to a student.  Selling gift cards are a great way for your students to share your classes with friends &amp; Family!</big></p> */}
          <FormsTable
            {...props}
            history={history}
            baseUrl={match.url}
            />
        </section>

      )}
    </div>
    </>
    );
  }

  return (
    <Switch>
      <Route path={`${props.match.url}/form/:formId`} component={SubmissionsPage} />
      <Route path="/">
        <Packages />
      </Route>
    </Switch>
  );
}

export default FormsPage;
